(function () {
  'use strict';

  // The empty-cart slider is initialised by theme.js (slider_empty_carttype)
  // while the empty message is still hidden, so Flickity measures a zero-width
  // container and the cells collapse. This re-measures it as soon as the block
  // actually becomes visible, and initialises it if the theme never did.

  var SELECTOR = '[data-slider-id="slider_emp_cart"]';
  var timer = null;

  function isVisible(el) {
    return !!(el && el.offsetWidth > 0 && el.offsetHeight >= 0 && el.offsetParent !== null);
  }

  function instanceFor(el) {
    if (el._emptyCartFlickity) return el._emptyCartFlickity;
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      return window.Flickity.data(el) || null;
    }
    return null;
  }

  function boot(el) {
    if (typeof window.Flickity === 'undefined' || !el.children.length) return null;
    try {
      var isMobile = window.innerWidth < 768;
      var flkty = new window.Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: !isMobile,
        wrapAround: false,
        groupCells: false,
        adaptiveHeight: false,
        dragThreshold: 8,
        imagesLoaded: true,
        percentPosition: true
      });
      el._emptyCartFlickity = flkty;
      return flkty;
    } catch (e) {
      return null;
    }
  }

  function refresh() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!isVisible(el)) return;

      var flkty = instanceFor(el);

      if (!flkty) {
        flkty = boot(el);
        if (!flkty) return;
      }

      try {
        flkty.resize();
        setTimeout(function () {
          try { flkty.resize(); } catch (e) { /* noop */ }
        }, 200);
      } catch (e) { /* noop */ }
    });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay || 120);
  }

  // theme.js's CartDrawer.openCartDrawer() only registers `this.cartDrawer`
  // and `this.cartDrawerBody` with the scroll-lock library:
  //   document.dispatchEvent(new CustomEvent("theme:scroll:lock", {detail: this.cartDrawer}))
  //   document.dispatchEvent(new CustomEvent("theme:scroll:lock", {detail: this.cartDrawerBody}))
  // [data-empty-message] is a SIBLING of cartDrawerBody (not a descendant
  // reachable through it), so it was never added to the scroll-lock library's
  // allowed-touch-scroll targets. Result: the block can overflow and can be
  // scrolled programmatically (scrollTop) or with a mouse wheel, but a real
  // finger drag on mobile is always preventDefault()'d — it cannot be
  // scrolled by touch at all. Registering it the same way theme.js registers
  // the other two elements fixes this without touching the compiled bundle.
  document.addEventListener('theme:cart:open', function () {
    var emptyMessage = document.querySelector('[data-empty-message]');
    if (emptyMessage) {
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: emptyMessage
      }));
    }
  });

  function start() {
    var drawer = document.querySelector('[data-cart-drawer]') || document.body;

    new MutationObserver(function () {
      schedule(120);
    }).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-cart-drawer-toggle], [data-item-remove], [data-quantity-button], .cart__item__remove')) {
        schedule(350);
      }
    });

    window.addEventListener('resize', function () { schedule(200); });

    schedule(400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
